<template>
  <!-- <chat :msg="msg" @sendMsg="sendMsg" @sendReplyMsg="sendReplyMsg"/> -->
  <b-row>
    <b-col lg="9" md="12" xs="12">
      <!-- <clients :obj="form" @openclient="openclient" :showComp="true" /> -->

      <!-- нові номери клієнти -->
      <clientNumbers
        :obj="ticket"
        @openclient="openclient"
        @updateCard="updateCard"
      />
      <!-- нові номери клієнти -->
    </b-col>
  </b-row>
</template>

<script>
import clientNumbers from "../../../view/formright/clientnumberNew.vue";
export default {
  name: "ClientsTab",
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  components: {
    clientNumbers,
  },
  methods: {
    openclient(e) {
      this.$emit("openclient", e);
    },
    updateCard() {
      this.$emit("updateCard");
    },
  },
};
</script>
